import type { Theme } from '@material-ui/core';

type RouteMaxTheme = Theme & {
  shadowColor?: string;
  ModalBGColor?: string;
  notificationColor?: string;
  scrollThumbColor?: string;
  TextColor?: string;
  textFontSize?: number | string;
  white?: string;
};

const styles = (theme: Theme) => {
  const routeMaxTheme = theme as RouteMaxTheme;

  return {
    container: {
      position: 'absolute' as const,
      top: 30,
      right: 8,
      width: 364,
      maxWidth: 'calc(100vw - 16px)',
      height: 'auto',
      maxHeight: '50vh',
      overflowY: 'auto' as const,
      boxShadow: `0px 4px 4px ${routeMaxTheme.shadowColor}`,
      backgroundColor: routeMaxTheme.ModalBGColor,
      color: routeMaxTheme.notificationColor,
    },
    notificationWrapper: {
      position: 'relative' as const,
    },
    filterRow: {
      display: 'flex',
      flexWrap: 'wrap' as const,
      padding: '12px 12px 8px',
    },
    filterChip: {
      border: `1px solid ${routeMaxTheme.scrollThumbColor}`,
      backgroundColor: routeMaxTheme.ModalBGColor,
      color: routeMaxTheme.TextColor,
      borderRadius: 16,
      padding: '4px 12px',
      fontSize: routeMaxTheme.textFontSize,
      lineHeight: '16px',
      cursor: 'pointer',
      marginRight: 6,
      marginBottom: 4,
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2,
      },
    },
    filterChipActive: {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: routeMaxTheme.white,
    },
    emptyMsgContainer: {
      display: 'flex',
      flexDirection: 'column' as const,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      minHeight: 120,
      padding: 16,
    },
    emptyMsgIcon: { fontSize: '45px', marginBottom: '10px' },
    emptyMsgText: {},
    alertNotification: {
      height: 'auto',
    },
  };
};

export default styles;
